import React from "react";
import Barcode0 from "./Barcode0";
import { elakayAutoText } from "./dataElakay";

// Shared printable table for the Provider My Products / Orders / Inventory print views (ticket
// parts 5-9): same header banner + QR + row striping + FILTER PRODUCT variant block as the
// existing "My Shop" print table (printerMyshop.js), but with a caller-supplied, variable column
// set instead of a fixed 6-column shape -- one table renderer, never a copy per print type.
// `columns`: [{ key, label }]. `rows`: [{ cells: { [key]: node }, variants?: [{ label, node }] }].
export default function GenericPrintTable({ columns, rows, canvasId = "qrcode-print-generic" }) {
  return (
    <table className="print-generic-table">
      <thead>
        <tr>
          <th colSpan={Math.max(1, columns.length - 1)} className="table-header-logo">{elakayAutoText("h_pps_website", "www.elakay.com")}</th>
          <th className="table-header-qr">
            <Barcode0 code={"qrcode"} height={14} scale={1} includetext={false} canvas={canvasId} />
          </th>
        </tr>
        <tr className="table-columns-header">
          <th className="pg-num">#</th>
          {columns.map((c) => <th key={c.key}>{c.label}</th>)}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => {
          const rowClass = index % 2 === 0 ? "product-row-even" : "product-row-odd";
          return (
            <React.Fragment key={row.key ?? index}>
              <tr className={`product-main-row ${rowClass}`}>
                <td className="pg-num-col">{index + 1}</td>
                {columns.map((c) => <td key={c.key}>{row.cells[c.key]}</td>)}
              </tr>
              {row.variants?.length > 0 && (
                <tr className={`filters-row ${rowClass}`}>
                  <td className="filters-label">{elakayAutoText("h_pps_variants", "Variants")}</td>
                  <td colSpan={columns.length}>
                    <div className="filters-inline-container">
                      {row.variants.map((v, i) => <div key={i} className="filter-inline-item">{v}</div>)}
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  );
}
